import { render, staticRenderFns } from "./SchoolBusInfo.vue?vue&type=template&id=8210c7d6&scoped=true&"
import script from "./SchoolBusInfo.vue?vue&type=script&lang=js&"
export * from "./SchoolBusInfo.vue?vue&type=script&lang=js&"
import style0 from "./SchoolBusInfo.vue?vue&type=style&index=0&id=8210c7d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8210c7d6",
  null
  
)

export default component.exports